import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SocialMediaComponent} from './social-media/social-media.component';
import {TextLinksComponent} from './text-links/text-links.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {FooterComponent} from './footer.component';
import {CountrySelectorModule} from '../header/country-selector/country-selector.module';
import {SapLogoModule} from '../header/sap-logo/sap-logo.module';
import {GenericLinkModule, PageLayoutModule} from '@spartacus/storefront';
import {FooterContainerComponent} from './footer-container/footer-container.component';


@NgModule({
  declarations: [
    SocialMediaComponent,
    TextLinksComponent,
    FooterComponent,
    FooterContainerComponent,
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        FooterNavigationComponent: {
          component: FooterComponent
        }
      }
    }),
    I18nModule,
    CountrySelectorModule,
    SapLogoModule,
    GenericLinkModule,
    PageLayoutModule,
  ],
  exports: [
    TextLinksComponent,
    FooterContainerComponent
  ]
})
export class FooterModule {
}
